function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="6"
      fill="none"
      viewBox="0 0 12 6"
    >
      <path fill="#0B223C" d="M12 0H0l6 6 6-6z"></path>
    </svg>
  );
}

export default Icon;
